import React from 'react';
import {
  IconServer,
  IconActivity,
  IconSettings,
  IconTrash,
  IconCpu,
  IconCpu2,
  IconDeviceSdCard
} from '@tabler/icons-react';
import { getFlagCode } from '../../../utils/countryUtils';
import { getStatusBadge, formatNodeName, formatNodeLocation, formatNodeHost } from '../../../utils/nodeHelpers';
import NodeResourceBar from './NodeResourceBar';

const NodeCard = ({ node, onEdit, onDelete }) => {
  return (
    <div className="bg-white dark:bg-dark-900 border border-gray-200 dark:border-dark-800 rounded-2xl p-6 hover:border-primary-500/30 transition-colors">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <span className={`fi fi-${getFlagCode(node.flag)} text-3xl mr-3 rounded overflow-hidden`}></span>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {formatNodeName(node)}
            </h3>
            <p className="text-sm text-gray-600 dark:text-dark-400">
              {formatNodeLocation(node)}
            </p>
          </div>
        </div>
        {getStatusBadge(node.status)}
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 dark:text-dark-400 flex items-center">
            <IconServer className="w-4 h-4 mr-1" />
            {formatNodeHost(node)}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 dark:text-dark-400 flex items-center">
            <IconActivity className="w-4 h-4 mr-1" />
            {node.active_tunnels || 0} активных · {node.total_tunnels || 0} всего
          </span>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <NodeResourceBar label={<><IconCpu className="w-3 h-3 mr-1" />CPU</>} value={node.cpu_usage} color="primary" />
        <NodeResourceBar label={<><IconCpu2 className="w-3 h-3 mr-1" />Память</>} value={node.memory_usage} color="green" />
        <NodeResourceBar label={<><IconDeviceSdCard className="w-3 h-3 mr-1" />Диск</>} value={node.disk_usage} color="purple" />
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => onEdit(node)}
          className="flex-1 inline-flex items-center justify-center px-3 py-2 border border-gray-200 dark:border-dark-800 rounded-lg text-sm font-medium text-gray-700 dark:text-dark-300 bg-white dark:bg-dark-900 hover:bg-gray-50 dark:hover:bg-dark-800 transition-colors"
        >
          <IconSettings className="w-4 h-4 mr-1" />
          Редактировать
        </button>
        <button
          onClick={() => onDelete(node.id)}
          className="px-3 py-2 border border-red-200 dark:border-red-800/30 rounded-lg text-sm font-medium text-red-600 dark:text-red-400 bg-white dark:bg-dark-900 hover:bg-red-50 dark:hover:bg-red-500/10 transition-colors"
        >
          <IconTrash className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default NodeCard;